module.exports = __webpack_public_path__ + "static/01-392762a8ecab7d76b529df0128ea0799.jpg";